import React, { useMemo } from 'react';
import { useModalWatch } from '../../../../shared/packages/modalManager';
import { modalNames } from '../../../../shared/configs/modal';
import { fieldNames } from '../../constants';
import { dateTime } from '../../../../shared/packages/dateTime';
import { FormControllerProvider } from '../../../../../../helpers/formManager';

export const FormProvider = ({ children }) => {
  const attachment = useModalWatch({
    name: modalNames.attachmentsForm,
    selector: (state) => state?.props?.attachment,
  });

  const options = useMemo(() => {
    return attachment
      ? {
          values: {
            [fieldNames.name]: attachment.name,
            [fieldNames.description]: attachment.description,
            [fieldNames.availableToClient]: attachment.availableForClient,
            [fieldNames.fromDate]: attachment.fromDate
              ? dateTime(attachment.fromDate)
              : undefined,
            [fieldNames.toDate]: attachment.toDate
              ? dateTime(attachment.toDate)
              : undefined,
          },
        }
      : undefined;
  }, [attachment]);

  return (
    <FormControllerProvider options={options}>
      {children}
    </FormControllerProvider>
  );
};
